Vue.component('chat', require('./Chat.vue').default);
